import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";

export const CardSection = ({
  className,
  header,
  footer,
  actions,
  empty,
  ...props
}) => {
  const prefixCls = "card__section";

  /*eslint-disable no-nested-ternary */
  const type = header
    ? "header"
    : footer ? "footer" : actions ? "actions" : empty ? "empty" : null;
  /*eslint-enable no-nested-ternary */

  const componentCls = classnames(
    prefixCls,
    {
      [`${prefixCls}--${type}`]: type,
    },
    className
  );

  return <div className={componentCls} {...props} />;
};

CardSection.propTypes = {
  className: PropTypes.string,
  header: PropTypes.bool,
  footer: PropTypes.bool,
  actions: PropTypes.bool,
  empty: PropTypes.bool,
};

export default CardSection;



// WEBPACK FOOTER //
// ./casper/sass/components/card/card-section.js